(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collection-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;

    const card = event.target.closest('[data-card-href]');
    if (!card) return;

    // Real links and form fields keep their own behavior
    if (event.target.closest('a[href], input, select, textarea')) return;

    const href = card.getAttribute('data-card-href');
    if (!href) return;

    if (event.metaKey || event.ctrlKey) {
      window.open(href, '_blank', 'noopener');
      return;
    }

    window.location.assign(href);
  });
  } catch(e) { console.error(e); }
})();

})();
